<button class="btn btn-outline" (click)="resetAll.emit()">{{ 'DEFINE.RESET_ALL' | translate }}</button>
<button class="btn btn-primary" (click)="saveToSpaces.emit()">{{ 'DEFINE.SAVE_TO_SPACES' | translate }}</button>
